export {
  default as workspace,
  ReactComponent as Workspace,
} from '@assets/icons/features-and-amenities/workspace.svg'    
